export default "__VITE_ASSET__be849d6a__"